import React, { useState, useEffect, useContext } from 'react'
import { Form, TextArea, Button, Rating, Grid, Icon, Label } from 'semantic-ui-react'
import API, { ResponseManagement, ErrorManagement } from '../../API';
import moment from 'moment';
import Utility from '../../Utility';
import { toast } from 'react-toastify';
import GlobalContext from '../../contexts/GlobalContext';

/**
 * @param {*rating, bookingFolder} props 
 */
function OpinionForm(props) {

  const [globalContext] = useContext(GlobalContext);
  const [globalRate, setGlobalRate] = useState(0);
  const [stateRate, setStateRate] = useState([]);
  const [ratingTab, setRatingTab] = useState([]);
  const [folderId, setFolderId] = useState(null);
  const [commentState, setCommentState] = useState("");
  
  const [dateExpire, setDateExpire] = useState(false);

  useEffect(() => {
    const date = props.rating.date;

    if(date !== undefined) {
      const today = moment().format();
      const notationDate = moment(date).format();
      const dateLimit = moment(notationDate).add(1, 'day').format();

      // console.log('today', today, 'dateLimit', dateLimit, 'notationDate', notationDate)

      if(today > dateLimit) {
        setDateExpire(true);
      }

    }

  }, [props.rating])


  useEffect(() => {
    let ratesTab = [];
    setRatingTab(props.rating);
    setCommentState(props.rating.comment);
    if(props.rating.rates && props.rating.rates.length > 0) {
      props.rating.rates.forEach(rate => {
        ratesTab.push({id: rate.id, name: rate.name, rate: rate.rate === 0 ? 5 : rate.rate});
      })
    }
    setStateRate(ratesTab);
    if(props.bookingFolder) {
      setFolderId(props.bookingFolder.id);
    }

  }, [props.rating, props.bookingFolder])
  
  useEffect(() => {
    let moyenne = 0;
    stateRate.map(obj => {
      return moyenne += obj.rate;
    });

    if(ratingTab.rates && ratingTab.rates.length > 0) {
      setGlobalRate(moyenne / ratingTab.rates.length);
    }

  }, [stateRate, ratingTab, localStorage.getItem('lang')]);// eslint-disable-line react-hooks/exhaustive-deps


  const handleChange = (e, data) => {
    let newState = stateRate;
    newState = newState.filter(state => state.name !== data.name);
    newState.push({ id: data.id, name: data.name, rate: data.rating });
    setStateRate(newState);
  }

  const getDefaultRating = name => {
    let rate = 0
    stateRate.forEach(state => {
      if (state.name === name) {
        rate = state.rate
      }
    })

    return rate === 0 ? 5 : rate;
  }

  const getRatings = () => {
    const temp = [];
    if(ratingTab.rates && ratingTab.rates.length > 0) {
      ratingTab.rates.forEach(rate =>  {// eslint-disable-line no-unused-vars
        let nameIcon = "dollar";
        if(rate.name === "quality") {
          nameIcon = "graduation"
        } else if (rate.name === "service") {
          nameIcon = "question"
        } else if (rate.name === "location") {
          nameIcon = "location arrow"
        }
        temp.push(
          <Grid.Column key={rate.id} className="pt-0 pl-3 pr-2" mobile={16} computer={4}>
            <div className="d-flex justify-content-center">
              <Icon name={nameIcon} />
              <Form.Field
                className="d-flex"
                id={`form-input-control-${rate.id}`}
                control={() => <Rating disabled={dateExpire} id={rate.id} className="ml-2" onRate={handleChange} name={rate.name} maxRating={5} defaultRating={getDefaultRating(rate.name)} icon="star" size="huge" />}
                label={globalContext.translations[rate.name]}
                placeholder={globalContext.translations[rate.name]}
              />
            </div>
          </Grid.Column>
        );
      })
    }
    // ratings
    return (
      <Grid columns="equal" style={{ height: '100%',width:'100%' }}>
        <Grid.Row centered>
          {temp}
        </Grid.Row>
      </Grid>
    )
  }

  const sendOpinion = () => {
    const e = document.querySelector('#form-button-control-send');
    e.classList.add('loading', 'disabled');

    const data = {
      data: {
        bookingFolderId: folderId,
        rating: {
          comment: commentState,
          averageRate: globalRate.toString(),
          rates: stateRate
        }
      }
    }

    API.post(Utility.getUrlAjax() + `/updateRatingAction`, JSON.stringify(data))
      .then(response => {
        ResponseManagement(response,
          () => {
            e.classList.remove('loading', 'disabled');
            toast.success(globalContext.translations.success);
          },
          () => {

          }
        )
      })
      .catch(error => {
        ErrorManagement(error, () => {});
      }) 

  }

  return (
    <Form className="p-3">
      <div className="text-center">
        <Label className="mb-5" color={dateExpire ? 'red' : 'blue'} >{dateExpire ? globalContext.translations.youCanNoLongerChangeYourOpinion : globalContext.translations.youCanChangeYourReviewForTheFirst24HoursAfterTheFirstValidation}</Label>
      </div>
      <Form.Group widths="equal">
        {getRatings()}
      </Form.Group>
      <div className="p-4">
        <Form.Group widths="equal">
          <Form.Field
            id="form-textarea-control-opinion"
            readOnly={dateExpire}
            control={TextArea}
            value={commentState}
            onChange={(ev) => setCommentState(ev.currentTarget.value)}
            label={globalContext.translations.bookingOpinion}
            placeholder={globalContext.translations.bookingOpinion}
            spellCheck="false"
          />
        </Form.Group>
        <Form.Group widths="2">
          <Form.Field
            id="form-input-control-global"
            control={() => <Rating disabled maxRating={5} defaultRating={globalRate} icon="star" size="large" />}
            label={globalContext.translations.bookingNotationGlobal}
            placeholder={globalContext.translations.bookingNotationGlobal}
          />
          <Form.Field
            id="form-button-control-send"
            disabled={dateExpire}
            control={Button}
            onClick={sendOpinion}
            positive
            floated="right"
            content={globalContext.translations.validate}
          />
        </Form.Group>
      </div>
    </Form>
  )
}

export default OpinionForm